<template>
  <div class="custom-section-box">
    <div>
      <a-row :gutter="10" type="flex">
        <a-col :xs="24" :lg="4">
          <span class="text-span-title">Relationship</span>
        </a-col>
        <a-col :xs="24" :lg="4">
          <span class="text-span-title">Global No.</span>
        </a-col>
      </a-row>
      <a-row :gutter="10" v-for="(p, pindex) in dataList" :key="'realation-ship-row-' + pindex" class="realation-row">
        <a-col :xs="24" :lg="4">
          <a-select
            :dropdownMatchSelectWidth="false"
            optionFilterProp="children"
            v-model="p.relationshipId"
          >
            <a-select-option value="">&nbsp;</a-select-option>
            <a-select-option v-for="c in realationShipList" :key="'rsList-' + c.id" :value="c.id">{{ c.rsName }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :xs="24" :lg="4">
          <a-input v-model="p.globalCode" />
        </a-col>
        <a-col :xs="24" :lg="4" style="line-height: 32px;">
          <a @click="handleAdd" v-if="pindex == (dataList.length - 1)">
            <a-icon type="plus"/>
          </a>
          <a-divider type="vertical" v-if="(pindex == (dataList.length - 1) && dataList.length !== 1)" />
          <a-popconfirm
            v-if="dataList.length !== 1"
            title="Are you sure?"
            ok-text="Yes"
            cancel-text="No"
            @confirm="handleDelete(pindex)"
          >
            <a><a-icon type="delete" style="color:#eb2f96;" /></a>
          </a-popconfirm>
        </a-col>
      </a-row>
    </div>
    
  </div>
</template>

<script>

export default {
  name: 'CdbCustomerRelationship',
  components: {
  },
  props: {
    initData: {
      type: Array,
      default: () => []
    },
    realationShipList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      dataList: []
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    // 初始化数据
    async loadData() {
      this.dataList = this.copyDataByJSON(this.initData) || []
      if (!this.dataList || this.dataList.length == 0) {
        this.dataList.push({
          relationshipId: null,
          globalCode: ''
        })
      }
    },
    handleAdd () {
      this.dataList.push({
        relationshipId: null,
        globalCode: ''
      })
    },
    handleDelete (index) {
      this.dataList.splice(index, 1)
    },
  },
  watch: {
    initData: {
      handler(newVal) {
        this.loadData(newVal)
      },
      immediate: true
    }
  }
}
</script>
<style lang="less" scoped>
.realation-row:not(:last-child) {
  margin-bottom: 5px;
}
</style>
